module.exports = __webpack_public_path__ + "static/media/logo.98f542d0.svg";